module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-costume-3-0224a93159c769f4de71fe2b8cedb436.jpg";